module.exports = "<p>\n  new-game-menu works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-game-menu/new-game-menu.component.html
// module id = ./src/app/new-game-menu/new-game-menu.component.html
// module chunks = 1